import { createGlobalStyle } from "styled-components";
import theme from "./theme";

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background-color: ${theme.bg};
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    color: ${theme.textMain};
  }

  button,
  [role="button"],
  input[type="button"],
  input[type="submit"],
  input[type="reset"] {
    transition: transform 0.12s ease, filter 0.12s ease;
  }

  button:active,
  [role="button"]:active,
  input[type="button"]:active,
  input[type="submit"]:active,
  input[type="reset"]:active {
    transform: translateY(1px) scale(0.985);
    filter: brightness(0.98);
  }
`;

export default GlobalStyle;
